
const Index = r => require.ensure([], () => r(require('./Index')), 'newGroupActivities')
const newGroup = r => require.ensure([], () => r(require('./newGroup')), 'newGroup')
const joinGroup = r => require.ensure([], () => r(require('./newGroupDetail')), 'newGroupDetail')
const ruler = r => require.ensure([], () => r(require('./ruler')), 'ruler')
export default {
  path: '/newGroup',
  component: Index,
  children: [
    {
      // http://0.0.0.0:8080/#/newGroup/groups
      meta: {
        title: ''
      },
      path: 'groups',
      name: 'NewGroup',
      component: newGroup
    },
    {
      // http://0.0.0.0:8080/#/newGroup/join-group
      meta: {
        title: ''
      },
      path: 'join-group',
      name: 'joinGroup',
      component: joinGroup
    },
    {
      // http://0.0.0.0:8080/#/newGroup/ruler
      meta: {
        title: '超级顾问拼团拿奖金'
      },
      path: 'ruler',
      name: 'ruler',
      component: ruler
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/newGroupActivities/router.js